import { Component, OnInit } from '@angular/core'
import { FieldArrayType, FormlyModule } from '@ngx-formly/core'

@Component({
  selector: 'app-repeat-field-type',
  standalone: true,
  imports: [FormlyModule],
  templateUrl: './repeat-field-type.component.html',
})
export class RepeatFieldTypeComponent extends FieldArrayType implements OnInit {
  public ngOnInit(): void {
    this.field.props.remove = this.remove.bind(this)
    this.field.props.add = this.add.bind(this)
  }
}
